import Loading from 'app/common/components/Loader'
import type { SurveyDetails } from 'app/common/types/surveys'

import { SurveyChart } from './SurveyChart'
import styles from './SurveyDetailsChart.module.scss'


type Props = {
  data: SurveyDetails | null
  loading: boolean
}

export const SurveyDetailsChart = ({ data, loading }: Props) => (
  <div className={styles.root}>
    {loading && (
      <div className={styles.loadingStatus} role="status" aria-label="Обновляем диаграмму">
        <Loading className={styles.loading} />
      </div>
    )}
    {!loading && data && <SurveyChart data={data} />}
  </div>
)
